// @flow
export const API = '/api/v1';

export const STORAGE_KEY = 'portfolioAdmin';
export const ADMIN_USER_NAME = 'administrator';

// Product Ids
export const SN_TYPE_STUDIO = 'PS';
export const SN_TYPE_SERVER = 'PP';
export const SN_TYPE_NETPUBLISH = 'NP';
export const SN_TYPE_SINGLESIGNON = 'SO';
export const SN_TYPE_USERCOUNT = 'PC';
export const SN_TYPE_MEDIAENGINE = 'ME';
export const SN_TYPE_ASSETCAP = 'AS';
export const SN_TYPE_API = 'PA';
export const SN_TYPE_DEMO = 'PD';
export const SN_TYPE_SMART_KEYWORDS = 'SK';

export const SN_LENGTH = 29;

// Product Types
export const PRODUCT_TYPE_DEMO = 'Demo';
export const PRODUCT_TYPE_SERVER = 'Server';
export const PRODUCT_TYPE_STUDIO = 'Studio';
export const PRODUCT_TYPE_NONE = 'None';

// Feature Constraints
export const ASSET_CAP_QUANTUM = 250000;
export const SMART_KEYWORDS_ASSET_CAP_QUANTUM = 250000;
export const MAX_NUM_ASSETS = 10000000;
export const MAX_NUM_CATALOGS = 9999;
export const MAX_NUM_MEDIAENGINES = 5;
export const MAX_NUM_SEATS = 1000;
export const MAX_NUM_ASSETS_STUDIO = 100000;
export const MAX_NUM_CATALOGS_STUDIO = 1;
export const MAX_NUM_MEDIAENGINES_STUDIO = 1;
export const MAX_NUM_SEATS_STUDIO = 3;

// Media Engine Constants
export const MEDIA_ENGINE_TYPE_BUILT_IN = 'BuiltIn';
export const MEDIA_ENGINE_DEFAULT_PORT = 9877;

// Server Running States
export const SERVER_STATE_STARTING = 'starting';
export const SERVER_STATE_STARTED = 'started';
export const SERVER_STATE_STOPPED = 'stopped';
export const SERVER_STATE_STOPPING = 'stopping';
export const SERVER_STATE_UNKNOWN = 'unknown';

// Catalog Properties
export const CATALOG_PROPERTY_KEY = {
  CATALOG_DETAILS: 'catalogDetails',
  CATALOGING_OPTIONS: 'catalogingOptions',
  DISK_PREVIEW_INFO: 'diskPreviewInfo',
  EXCLUSION_INFO: 'exclusionInfo',
  SMART_KEYWORDS_SETTINGS: 'smartKeywordsSettings',
  INGEST_CONFIG: 'ingestConfig',
  INGEST_CONFIG_PREDEF: 'ingestConfig_predef',
};

export const CATALOG_STORAGE_TYPE = {
  FILESYSTEM: 'Filesystem',
  VAULT: 'Vault',
  S3: 'S3',
};

export const CATALOG_STATUS = {
  OFFLINE: 'offline',
  ONLINE: 'online',
};

export const DEFAULT_CATALOG_TYPE_NAMES = [
  'Allgemeine Verwendung',
  'General Use',
  'Utilisation générale',
  '汎用',
];

// Dialog Ids
export const ABOUT_PANEL_ID = 'ABOUT_PANEL_ID';
export const ADD_EXTRACT_MAPPING_PANEL_ID = 'ADD_EXTRACT_MAPPING_PANEL_ID';
export const ADD_LICENSE_PANEL_ID = 'ADD_LICENSE_PANEL_ID';
export const BACKUP_RESTORE_PROGRESS_PANEL_ID =
  'BACKUP_RESTORE_PROGRESS_PANEL_ID';
export const CATALOG_TEMPLATES_PANEL_ID = 'CATALOG_TEMPLATES_PANEL_ID';
export const BROWSE_SERVER_FOLDERS_PANEL_ID = 'BROWSE_SERVER_FOLDERS_PANEL_ID';
export const CERT_UPLOAD_PANEL_ID = 'CERT_UPLOAD_PANEL_ID';
export const CONFIRM_USER_ROLE_CHANGE_PANEL_ID =
  'CONFIRM_USER_ROLE_CHANGE_PANEL_ID';
export const CREATE_CATALOG_PANEL_ID = 'CREATE_CATALOG_PANEL_ID';
export const CREATE_CERT_REQUEST_PANEL_ID = 'CREATE_CERT_REQUEST_PANEL_ID';
export const CREATE_FIELD_PANEL_ID = 'CREATE_FIELD_PANEL_ID';
export const CREATE_MEDIA_ENGINE_PANEL_ID = 'CREATE_MEDIA_ENGINE_PANEL_ID';
export const CREATE_METADATA_PANEL_ID = 'CREATE_METADATA_PANEL_ID';
export const CREATE_METADATA_FORM_ID = 'CREATE_METADATA_FORM_ID';
export const CREATE_USER_PANEL_ID = 'CREATE_USER_PANEL_ID';
export const CREATE_XMP_NAMESPACE_PANEL_ID = 'CREATE_XMP_NAMESPACE_PANEL_ID';
export const DELETE_USER_PANEL_ID = 'DELETE_USER_PANEL_ID';
export const DELETE_VAULT_CATALOG_PANEL_ID = 'DELETE_VAULT_CATALOG_PANEL_ID';
export const DIAGNOSTIC_DATA_PANEL_ID = 'DIAGNOSTIC_DATA_PANEL_ID';
export const DIR_SVC_MAPPINGS_PANEL_ID = 'DIR_SVC_MAPPINGS_PANEL_ID';
export const METADATA_PANEL_ID = 'METADATA_PANEL_ID';
export const SET_ACCOUNT_PANEL_ID = 'SET_ACCOUNT_PANEL_ID';
export const SET_SYSTEM_PANEL_ID = 'SET_SYSTEM_PANEL_ID';
export const XMP_NAMESPACE_PANEL_ID = 'XMP_NAMESPACE_PANEL_ID';

// Form Ids
export const CREATE_USER_FORM = 'CREATE_USER_FORM';
export const USER_DETAILS_FORM = 'USER_DETAILS_FORM';
export const CREATE_FIELD_FORM = 'CREATE_FIELD_FORM';
export const BRANDING_SETTINGS_FORM = 'BRANDING_SETTINGS_FORM';
export const EMAIL_CONFIG_FORM = 'EMAIL_CONFIG_FORM';

// Versions
export const appVersion = process.env.REACT_APP_APPVERSION || '0.0.0';
export const buildVersion =
  process.env.REACT_APP_BUILDVERSION || '00000000-0000000';
export const version = `${appVersion} (${buildVersion})`;

// Users
export const CLEANUP_TOKEN = {
  makePrivateGalleriesPublic: 'make private galleries public',
  deletePrivateGalleries: 'delete private galleries',
};

// Keys of persisted data
export const USER_DATA = {
  LOCALE: 'locale',
};

// Smart Keyword Settings
export const CONFIDENCE_LEVEL = 'confidenceLevel';
export const NUM_KEYWORDS = 'numKeywords';

// AdminFileTransferServlet upload
export const ACTION_BRANDING_UPLOAD = 'brandingUpload';
export const BRANDING_UPLOAD_FILENAME = 'web_client_login_screen_image';



// WEBPACK FOOTER //
// ./src/util/constants.js